var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from "classnames";
import { computeThemeClassNames } from "@travel/shared/theme/ui";
import blockStyles from "../block/block.module.css";
import textStyles from "../../../../ui/text/text.module.css";
export function CMSBlock(blok, className) {
    var styleProps = computeCMSStyles(blok, className);
    var behaviorProps = computeBehaviors(blok);
    return __assign(__assign({}, styleProps), behaviorProps);
}
export function computeBehaviors(blok) {
    var _a;
    return (_a = blok === null || blok === void 0 ? void 0 : blok.behaviors) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, behaviorBlok) {
        switch (behaviorBlok === null || behaviorBlok === void 0 ? void 0 : behaviorBlok.component) {
            case "OpenLoginClickBehavior":
                break;
        }
        return acc;
    }, {});
}
export function computeCMSStyles(blok, startClassName) {
    if (startClassName === void 0) { startClassName = ""; }
    var styles = Array.isArray(blok) ? blok : blok === null || blok === void 0 ? void 0 : blok.styles;
    var _a = styles
        ? styles.reduce(function (_a, styleBlok) {
            var className = _a.className, style = _a.style, defaultTypeStyles = _a.defaultTypeStyles;
            switch (styleBlok.component) {
                case "BlockStyles":
                    var _b = computeCMSBlockStyles(__assign(__assign({}, styleBlok), { hidden: blok.hidden })), blockClassNames = _b.className, blockStyle = _b.style;
                    className = classNames(className, blockClassNames);
                    Object.assign(style, blockStyle);
                    break;
                case "TextStyles":
                    var _c = computeCMSTextStyle(styleBlok), textClassNames = _c.className, textStyle = _c.style, textHasDefaultTextStyles = _c.defaultTypeStyles;
                    className = classNames(className, textClassNames);
                    if (!textHasDefaultTextStyles) {
                        defaultTypeStyles = false;
                    }
                    Object.assign(style, textStyle);
                    break;
                case "ThemeStyles":
                    var themeClassNames = computeThemeClassNames(computeThemePallete(styleBlok));
                    className = classNames(className, themeClassNames);
                    break;
            }
            return {
                className: className,
                style: style,
                defaultTypeStyles: defaultTypeStyles,
            };
        }, { className: startClassName, style: {}, defaultTypeStyles: true })
        : { className: startClassName, style: {}, defaultTypeStyles: true }, className = _a.className, style = _a.style, defaultTypeStyles = _a.defaultTypeStyles;
    return { className: className, style: style, defaultTypeStyles: defaultTypeStyles };
}
function computeThemePallete(_a) {
    var _b = _a === void 0 ? {} : _a, background = _b.background, text = _b.text, border = _b.border, variant = _b.variant, darkBackground = _b.darkBackground, darkText = _b.darkText, darkBorder = _b.darkBorder;
    var palette = {
        background: background,
        text: text,
        border: border,
        dark: darkBackground || darkText || darkBorder
            ? {
                background: darkBackground,
                text: darkText,
                border: darkBackground,
            }
            : undefined,
    };
    return palette;
}
export function computeCMSBlockStyles(blok, startClassName) {
    var _a;
    var _b;
    var style = {
        gap: blok.gap,
        width: blok.width,
        height: blok.height,
        minWidth: blok.minWidth,
        minHeight: blok.minHeight,
        background: ((_b = blok.background) === null || _b === void 0 ? void 0 : _b.match(/primary|secondary|tertiary|body|grey/))
            ? "var(--travel-".concat(blok.background).concat(blok.background.match(/primary|secondary|tertiary/) ? "-color" : "", ")")
            : blok.background,
        padding: blok.padding,
        margin: blok.margin,
        border: blok.border,
        borderRadius: blok.borderRadius,
        //display: blok.display,
        flex: blok.flex,
        aspectRatio: blok.aspectRatio,
        position: blok.position,
        overflow: blok.overflow,
        overflowX: blok.overflowX,
        overflowY: blok.overflowY,
        zIndex: blok.zIndex,
        top: blok.top,
        right: blok.right,
        bottom: blok.bottom,
        left: blok.left,
        opacity: blok.opacity,
        boxShadow: blok.boxShadow,
    };
    if (blok.desiredWidth) {
        style.width = "100%";
        style.maxWidth = blok.desiredWidth;
    }
    if (blok.desiredHeight) {
        style.minHeight = blok.desiredHeight;
    }
    var className = classNames(startClassName, blockStyles["container"], [blockStyles[blok.wrap]], [blockStyles[blok.display]], [blockStyles["mobile-".concat(blok.displayMobile)]], [blockStyles["mobile-".concat(blok.positionMobile)]], [blockStyles["align-".concat(blok.align)]], [blockStyles["align-self-".concat(blok.alignSelf)]], [blockStyles["justify-self-".concat(blok.justifySelf)]], [blockStyles["mobile-align-self-".concat(blok.alignSelfMobile)]], [blockStyles["mobile-justify-self-".concat(blok.justifySelfMobile)]], [blockStyles["vmd-align-".concat(blok.alignTablet)]], [blockStyles["vsm-align-".concat(blok.alignMobile)]], [blockStyles["justify-".concat(blok.justify)]], [blockStyles["vmd-justify-".concat(blok.justifyTablet)]], [blockStyles["vsm-justify-".concat(blok.justifyMobile)]], [blockStyles["grid-col-".concat(blok.gridColumns)]], [blockStyles["grid-row-".concat(blok.gridRows)]], [blockStyles["mobile-grid-col-".concat(blok.gridColumnsMobile)]], [blockStyles["mobile-grid-row-".concat(blok.gridRowsMobile)]], (_a = {},
        _a[blockStyles["sm-fit-width"]] = blok.fitWidthSmall,
        _a[blockStyles["horizontal"]] = (blok === null || blok === void 0 ? void 0 : blok.direction) === "horizontal",
        _a[blockStyles["vertical"]] = (blok === null || blok === void 0 ? void 0 : blok.direction) === "vertical",
        _a[blockStyles["horizontal-reverse"]] = (blok === null || blok === void 0 ? void 0 : blok.direction) === "horizontal-reverse",
        _a[blockStyles["vsm-vertical"]] = (blok === null || blok === void 0 ? void 0 : blok.directionMobile) === "vertical",
        _a[blockStyles["vsm-vertical-reverse"]] = (blok === null || blok === void 0 ? void 0 : blok.mobileDirection) === "vertical-reverse",
        _a[blockStyles["vsm-horizontal"]] = (blok === null || blok === void 0 ? void 0 : blok.directionMobile) === "horizontal",
        _a[blockStyles["vsm-horizontal-reverse"]] = (blok === null || blok === void 0 ? void 0 : blok.directionMobile) === "vsm-horizontal-reverse",
        _a[blockStyles["vsm-vertical-reverse"]] = (blok === null || blok === void 0 ? void 0 : blok.directionMobile) === "vertical-reverse",
        _a[blockStyles["hidden"]] = !!blok.hidden,
        _a));
    return { className: className, style: style, defaultTypeStyles: !blok.fontSize };
}
export function computeCMSTextStyle(_a, startClassName) {
    var _b;
    var _c;
    var type = _a.type, underline = _a.underline, underlineTheme = _a.underlineTheme, blok = __rest(_a, ["type", "underline", "underlineTheme"]);
    if (startClassName === void 0) { startClassName = ""; }
    var isColorVariable = (_c = blok.color) === null || _c === void 0 ? void 0 : _c.match(/primary|secondary|tertiary|body|text/);
    var style = {
        color: isColorVariable ? undefined : blok.color,
        lineHeight: blok.lineHeight,
        letterSpacing: blok.letterSpacing,
        /*fontSize: blok.fontSize,
        fontWeight: blok.fontWeight,
        lineHeight: blok.lineHeight || undefined,
        letterSpacing: blok.letterSpacing,
        textAlign: blok.textAlign,
        textTransform: blok.textTransform,*/
    };
    var className = classNames(startClassName, textStyles["container"], textStyles[type], textStyles[blok.fontSize], textStyles[blok.fontWeight], textStyles[blok.textAlign], textStyles["mobile-".concat(blok.fontSizeMobile)], textStyles["mobile-".concat(blok.fontWeightMobile)], textStyles["mobile-".concat(blok.textAlignMobile)], (_b = {},
        _b[textStyles["has-underline"]] = !!underline,
        _b[textStyles["underline".concat(underline === true || underline === "sm" ? "" : "-".concat(underline))]] = !!underline,
        _b[textStyles["underline-".concat(underlineTheme)]] = !!underlineTheme,
        _b[textStyles["".concat(blok.color)]] = isColorVariable,
        _b[textStyles["dark-".concat(blok.darkModeColor)]] = !!blok.darkModeColor,
        _b));
    return { className: className, style: style, defaultTypeStyles: !blok.fontSize };
}
